import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AutenticacaoService } from 'app/services/autenticacao.service';
import { StorageService } from 'app/services/storage.service';
import { KeysStorage } from './keys-storage';

export const logadoGuard: CanActivateFn = () => {
    const autenticacaoService = inject(AutenticacaoService);
    const storage = inject(StorageService);
    const router = inject(Router);

    if (!autenticacaoService.isAuthenticated()) {
        return true;
    }

    // Already logged in: check if subscription is blocking access to the panel
    const dataFimTrialStr = storage.get(KeysStorage.dataFimTrial());
    const statusAssinaturaStr = storage.get(KeysStorage.statusAssinatura());

    if (dataFimTrialStr) {
        const trialExpirado = new Date(dataFimTrialStr) < new Date();
        const statusAtivo = statusAssinaturaStr === '2';

        if (trialExpirado && !statusAtivo) {
            router.navigate(['/assinatura']);
            return false;
        }
    }

    router.navigate(['/painel']);
    return false;
};
